import * as React from "react";
const SvgPause = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M.5 6.5V3.994C.5.883 2.703-.392 5.4 1.164l2.175 1.253L9.75 3.67c2.697 1.556 2.697 4.105 0 5.66l-2.175 1.254L5.4 11.837c-2.697 1.555-4.9.281-4.9-2.83z"
    />
  </svg>
);
export default SvgPause;
